// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__p48nS","is_select":"pagination_is_select__qZfdp"};